import type { DateRange } from '@/features/api/extranet/dto/shared'
import { createUtcDate, getToday, toISODateOnlyString } from '@/features/shared/tools'

export function getRangeDateConclusion(): DateRange {
  // Pour la Date min, j'ai pris une date min mais à redéfinir avec le métier
  const dateMin = createUtcDate(2018, 0, 1)
  const dateMax = getToday()

  const dateRange: DateRange = {
    start: toISODateOnlyString(dateMin),
    end: toISODateOnlyString(dateMax),
  }

  return dateRange
}
